<div class="">
  <h2 class="title pb-3 d-inline-flex">{{Header}}</h2>
  <button type="button" class="close closeModal" aria-label="Close" mat-dialog-close>
    <img src="./assets/close_side_nav.png">
  </button>

  <div class="row">
    <div class="col-md-12">
      <form *ngIf="formtype=='defineDocTypes'" [formGroup]="formdataCreatenewDoctypes">
        <div class="row">
          <div class="col-md-11 gx-0">
            <div class="row inputRow">
              <div class="col-md-12">

                <div class="row mb-3">
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Document Type</mat-label>
                      <input matInput id="commonText" name="document_type" placeholder="Document Type"
                        formControlName="document_type" autocomplete="off" (change)="onChangedocumenttype($event)"
                        required />
                        <mat-error
                        *ngIf="formdataCreatenewDoctypes.controls.document_type.hasError('document_type') || !formdataCreatenewDoctypes.controls.document_type.hasError('required')">
                        Please Enter a Valid Document Type(A-Z or a-z or 0-9)
                      </mat-error>

                    </mat-form-field>
                    <mat-error *ngIf="formdataCreatenewDoctypes.controls.document_type.errors">
                      <p *ngIf="formdataCreatenewDoctypes.controls.document_type.errors?.duplicateflag">
                        Document type already exists.Create a new document type.
                      </p>
                    </mat-error>
                  </div>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="formDropdown">
                      <mat-label>Visibility Type</mat-label>
                      <mat-select formControlName="visibility_type" name="account" placeholder="Visibility Type"
                        #accountFilter required>
                        <!-- <mat-select-filter *ngIf="accountFilter.focused"
                                                    [placeholder]="'Filter'" [displayMember]="'accountName'"
                                                    [array]="accountList"
                                                    (filteredReturn)="accountList1 = $event"></mat-select-filter> -->
                        <mat-option *ngFor="let i of visibilityList" [value]="i.visibility">{{i.visibility}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row inputRow" style="height: 40px">
                  <div class="col-md-4"></div>
                  <div class="col-md-6">
                    <div class="col-md-6">
                      <button [disabled]="btnEnabled" class="forsubmit schBtn button-right1"
                        (click)="onClickSubmitCreate(formdataCreatenewDoctypes.value)" aria-label="Close"
                        mat-dialog-close mat-button>
                        Create
                      </button>
                    </div>
                    <div class="col-md-6">
                      <button class="cancelButton r-20px" aria-label="Close" mat-dialog-close mat-button>
                        Cancel
                      </button>
                    </div>
                  </div>


                </div>


              </div>
            </div>
          </div>
        </div>


      </form>
      <form *ngIf="formtype=='editDocTypes'" [formGroup]="formdataEditDoctypes">
        <div class="row">
          <div class="col-md-11 gx-0">
            <div class="row inputRow">
              <div class="col-md-12">
                <br />
                <div class="row mb-3">
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Document Type</mat-label>
                      <input matInput id="commonText" name="document_type" [(ngModel)]="binddocumnetypedata"
                        placeholder="Document Type" formControlName="document_type" autocomplete="off" required />
                    </mat-form-field>
                  </div>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="formDropdown">
                      <mat-label>Visibility Type</mat-label>
                      <mat-select formControlName="visibility_type" name="account" [(ngModel)]="bindvisibilitydata"
                        placeholder="Visibility Type" #accountFilter required>
                        <!-- <mat-select-filter *ngIf="accountFilter.focused"
                                                    [placeholder]="'Filter'" [displayMember]="'accountName'"
                                                    [array]="accountList"
                                                    (filteredReturn)="accountList1 = $event"></mat-select-filter> -->
                        <mat-option *ngFor="let i of visibilityList" [value]="i.visibility">{{i.visibility}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row inputRow" style="height: 40px">
                  <div class="col-md-4"></div>
                  <div class="col-md-6">
                    <div class="col-md-6">
                      <button class="forsubmit schBtn button-right1"
                        (click)="onClickSubmitupdate(formdataEditDoctypes.value)" aria-label="Close" mat-dialog-close
                        mat-button>
                        Update
                      </button>
                    </div>
                    <div class="col-md-6">
                      <button class="cancelButton r-20px" aria-label="Close" mat-dialog-close mat-button>
                        Cancel
                      </button>
                    </div>
                  </div>


                </div>


              </div>
            </div>
          </div>
        </div>


      </form>
      <form *ngIf="formtype=='createNewTenant'" [formGroup]="formdataCreatenewTenant">
        <div class="row">
          <div class="col-md-11 gx-0">
            <div class="row inputRow">
              <div class="col-md-12">

                <div class="row mb-3">
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Name</mat-label>
                      <input matInput id="commonText" name="name" placeholder="Name" formControlName="name"
                        autocomplete="off" required />
                        <mat-error
                        *ngIf="formdataCreatenewTenant.controls.name.hasError('name') || !formdataCreatenewTenant.controls.name.hasError('required')">
                        Please Enter a Valid  Name(A-Z or a-z or 0-9)
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Username</mat-label>
                      <input matInput id="commonText" [(ngModel)]="bindusernamerandom" name="username"
                        placeholder="Username" formControlName="username" autocomplete="off" required />
                        <mat-error
                        *ngIf="formdataCreatenewTenant.controls.username.hasError('username') || !formdataCreatenewTenant.controls.username.hasError('required')">
                        Please Enter a Valid User Name(A-Z or a-z or 0-9 and special Chracter &%#@ )
                      </mat-error>
                    </mat-form-field>

                  </div>
                  <div *ngIf="formdataCreatenewTenant.controls.name.value" class="col-md-4">
                    <button class="generatebtn" (click)="makeRandom()">Genarate

                    </button>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Effective From</mat-label>
                      <input [(ngModel)]="effectiveForm" placeholder="Effective From" matInput [matDatepicker]="picker1"
                        formControlName="effectiveForm" name="effectiveForm" required autocomplete="off"
                        [min]="startDate" />
                      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Effective To</mat-label>
                      <input [(ngModel)]="effectiveTo" placeholder="Effective To" matInput [matDatepicker]="picker2"
                        formControlName="effectiveTo" name="effectiveTo" required autocomplete="off"
                        [min]="startDate" />
                      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                      <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">

                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Role</mat-label>
                      <mat-select formControlName="role">
                        <mat-select-filter [placeholder]="'Filter'" [displayMember]="'role_name'"
                          [array]="roledropdown1" (filteredReturn)="roledropdown1 = $event"></mat-select-filter>
                        <!-- <input (keyup)="onKey($event)" type="text" matInput> -->
                        <mat-option *ngFor="let i of roledropdown1" [value]="i.role_name">{{i.role_name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Email Id for sending details</mat-label>
                      <input matInput id="commonText" name="email_id_send" placeholder="Email Id for sending details"
                        formControlName="email_id_send" autocomplete="off" required />
                        <mat-error
                            *ngIf="formdataCreatenewTenant.controls.email_id_send.hasError('email_id_send') || !formdataCreatenewTenant.controls.email_id_send.hasError('required')">
                            Please Enter a Valid Email ID
                          </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">
                    <p class="subtextclass">Enable</p>
                    <mat-slide-toggle formControlName="tenantenableFlag"></mat-slide-toggle>
                  </div>
                </div>
                <div class="row inputRow" style="height: 40px">
                  <div class="col-md-4"></div>
                  <div class="col-md-6">
                    <div class="col-md-6">
                      <button class="forsubmit schBtn button-right1"
                        (click)="onClickSubmitcreatetenant(formdataCreatenewTenant.value)" aria-label="Close"
                        mat-dialog-close mat-button>
                        Create
                      </button>
                    </div>
                    <div class="col-md-6">
                      <button class="cancelButton r-20px" aria-label="Close" mat-dialog-close mat-button>
                        Cancel
                      </button>
                    </div>
                  </div>


                </div>


              </div>
            </div>
          </div>
        </div>


      </form>
      <form *ngIf="formtype=='editTenant'" [formGroup]="formdataEditTenant">
        <div class="row">
          <div class="col-md-11 gx-0">
            <div class="row inputRow">
              <div class="col-md-12">
                <br />
                <div class="row mb-3">
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Name</mat-label>
                      <input matInput id="commonText" name="name" placeholder="Name" [(ngModel)]="bindtenantname"
                        formControlName="name" autocomplete="off" required />
                    </mat-form-field>
                  </div>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Username</mat-label>
                      <input matInput id="commonText" name="username" placeholder="Username" [(ngModel)]="bindusername"
                        formControlName="username" autocomplete="off" required />
                    </mat-form-field>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Effective From</mat-label>
                      <input [(ngModel)]="bindeffectivefrom" placeholder="Effective From" matInput
                        [matDatepicker]="picker1" formControlName="effectiveForm" name="effectiveForm"
                        autocomplete="off" [min]="startDate" />
                      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Effective To</mat-label>
                      <input placeholder="Effective To" matInput [matDatepicker]="picker2" formControlName="effectiveTo"
                        [(ngModel)]="bindeffectiveto" name="effectiveTo" autocomplete="off" [min]="startDate" />
                      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                      <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">

                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Role</mat-label>
                      <mat-select formControlName="role" [(ngModel)]="bindroledetails">
                        <mat-select-filter [placeholder]="'Filter'" [displayMember]="'role_name'"
                          [array]="roledropdown1" (filteredReturn)="roledropdown1 = $event"></mat-select-filter>
                        <!-- <input (keyup)="onKey($event)" type="text" matInput> -->
                        <mat-option *ngFor="let i of roledropdown1" [value]="i.role_name">{{i.role_name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Email Id for sending details</mat-label>
                      <input matInput id="commonText" [(ngModel)]="bindemailidsend" name="email_id_send"
                        placeholder="Email Id for sending details" formControlName="email_id_send" autocomplete="off"
                        required />
                    </mat-form-field>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">
                    <p class="subtextclass">Enable</p>
                    <mat-slide-toggle [(ngModel)]="bindenable" formControlName="tenantenableFlag"></mat-slide-toggle>
                  </div>
                </div>
                <div class="row inputRow" style="height: 40px">
                  <div class="col-md-4"></div>
                  <div class="col-md-6">
                    <div class="col-md-6">
                      <button class="forsubmit schBtn button-right1"
                        (click)="onClickSubmitedittenant(formdataEditTenant.value)" aria-label="Close" mat-dialog-close
                        mat-button>
                        Update
                      </button>
                    </div>
                    <div class="col-md-6">
                      <button class="cancelButton r-20px" aria-label="Close" mat-dialog-close mat-button>
                        Cancel
                      </button>
                    </div>
                  </div>


                </div>


              </div>
            </div>
          </div>
        </div>


      </form>
      <form *ngIf="formtype=='editdocumentdata'" [formGroup]="formdataEditDocument">
        <div class="row">
          <div class="col-md-11 gx-0">
            <div class="row inputRow">
              <div class="col-md-12">
                <br />
                <div class="row mb-3">
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Doc ID</mat-label>
                      <input matInput id="commonText" name="doc_id" placeholder="Doc Id" [(ngModel)]="doc_id"
                        formControlName="doc_id" autocomplete="off" required />
                    </mat-form-field>
                  </div>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Doc Name</mat-label>
                      <input matInput id="commonText" name="doc_name" placeholder="Doc Name" [(ngModel)]="doc_name"
                        formControlName="doc_name" autocomplete="off" required />
                    </mat-form-field>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Description</mat-label>
                      <input matInput id="commonText" name="description" placeholder="description"
                        [(ngModel)]="description" formControlName="description" autocomplete="off" required />
                    </mat-form-field>
                  </div>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Version</mat-label>
                      <input matInput id="commonText" name="version" placeholder="version" [(ngModel)]="version"
                        formControlName="version" autocomplete="off" required />
                    </mat-form-field>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Tenant Id</mat-label>
                      <input matInput id="commonText" name="tenant_id" placeholder="tenant_id" [(ngModel)]="tenant_id"
                        formControlName="tenant_id" autocomplete="off" required />
                    </mat-form-field>
                  </div>
                  <div class="col-md-4">

                    <p class="subtextclass">Enabled flag</p>
                    <mat-slide-toggle [(ngModel)]="enabled_flag" formControlName="enabled_flag"></mat-slide-toggle>

                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">
                    <input type="file" formControlName="attachmentFileName"
                      class="col-md-6 massEventTemplateType form-control" id="attachmentFileName"
                      name="attachmentFileName" placeholder="Select file!"
                      accept=".txt, .doc, .docx, .pdf, .xls, .xlsx, .xlsb, .zip, .7z, .jpg, .jpeg, .odt, .ods, .csv"
                      (change)="onFileChange($event)" />
                    <span style="
                                color: grey;
                                font-size: 12px;
                                font-family: Segoe UI;
                              ">(Allowed File Type:pdf) (Max size is 2
                      MB)</span>
                    <mat-error *ngIf="formdataEditDocument.controls.attachmentFileName.errors">
                      <p *ngIf="formdataEditDocument.controls.attachmentFileName.errors?.format">
                        File format not supported.
                      </p>
                      <p *ngIf="formdataEditDocument.controls.attachmentFileName.errors?.size">
                        File size exceeded the limit. Maximum allowable size
                        is 2 MB.
                      </p>
                      <p *ngIf="formdataEditDocument.controls.attachmentFileName.errors?.specialCharacters">
                        File name sholud not contain any special characters.
                      </p>
                    </mat-error>
                  </div>
                </div>
                <div class="row inputRow" style="height: 40px">
                  <div class="col-md-4"></div>
                  <div class="col-md-6">
                    <div class="col-md-6">
                      <button class="forsubmit schBtn button-right1"
                        (click)="onClickSubmiteditdocumentdata(formdataEditDocument.value)" aria-label="Close"
                        mat-dialog-close mat-button>
                        Update
                      </button>
                    </div>
                    <div class="col-md-6">
                      <button class="cancelButton r-20px" aria-label="Close" mat-dialog-close mat-button>
                        Cancel
                      </button>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <form *ngIf="formtype=='createNewUser'" [formGroup]="formdataCreatenewUser">
        <div class="row">
          <div class="col-md-11 gx-0">
            <div class="row inputRow">
              <div class="col-md-12">

                <div class="row mb-3">
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Name</mat-label>
                      <input matInput id="commonText" name="name" placeholder="Name" formControlName="name"
                        autocomplete="off" required />
                        <mat-error
                        *ngIf="formdataCreatenewUser.controls.name.hasError('name') || !formdataCreatenewUser.controls.name.hasError('required')">
                        Please Enter a Valid  Name(A-Z or a-z or 0-9)
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Username</mat-label>
                      <input matInput id="commonText" [(ngModel)]="bindusernamerandomforUser" name="username"
                        placeholder="Username" formControlName="username" autocomplete="off" required />
                        <mat-error
                        *ngIf="formdataCreatenewUser.controls.username.hasError('username') || !formdataCreatenewUser.controls.username.hasError('required')">
                        Please Enter a Valid User Name(A-Z or a-z or 0-9 and special Chracter &%#@ )
                      </mat-error>
                    </mat-form-field>

                  </div>
                  <div *ngIf="formdataCreatenewUser.controls.name.value" class="col-md-4">
                    <button class="generatebtn" (click)="makeRandomUser()">Genarate

                    </button>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Effective From</mat-label>
                      <input [(ngModel)]="effectiveForm" placeholder="Effective From" matInput [matDatepicker]="picker1"
                        formControlName="effectiveForm" name="effectiveForm" required autocomplete="off"
                        [min]="startDate" />
                      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Effective To</mat-label>
                      <input [(ngModel)]="effectiveTo" placeholder="Effective To" matInput [matDatepicker]="picker2"
                        formControlName="effectiveTo" name="effectiveTo" required autocomplete="off"
                        [min]="startDate" />
                      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                      <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">

                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Role</mat-label>
                      <mat-select formControlName="role">
                        <mat-select-filter [placeholder]="'Filter'" [displayMember]="'role_name'"
                          [array]="roledropdownuser1" (filteredReturn)="roledropdownuser1 = $event"></mat-select-filter>
                        <!-- <input (keyup)="onKey($event)" type="text" matInput> -->
                        <mat-option *ngFor="let i of roledropdownuser1" [value]="i.role_name">{{i.role_name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Email Id for sending details</mat-label>
                      <input matInput id="commonText" name="email_id_send" placeholder="Email Id for sending details"
                        formControlName="email_id_send" autocomplete="off" required />
                        <mat-error
                            *ngIf="formdataCreatenewUser.controls.email_id_send.hasError('email_id_send') || !formdataCreatenewUser.controls.email_id_send.hasError('required')">
                            Please Enter a Valid Email ID
                          </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Tenant</mat-label>
                      <mat-select  formControlName="tenant" [(ngModel)]="tenant_name_deafult" multiple>
                        <mat-select-filter [placeholder]="'Filter'" [displayMember]="'role_name'"
                          [array]="tenantdropdownuser1" (filteredReturn)="tenantdropdownuser1 = $event"></mat-select-filter>
                        <!-- <input (keyup)="onKey($event)" type="text" matInput> -->
                        <mat-option *ngFor="let i of tenantdropdownuser1" [value]="i.name">{{i.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">
                    <p class="subtextclass">Enable</p>
                    <mat-slide-toggle formControlName="userenableFlag"></mat-slide-toggle>
                  </div>
                </div>
                <div class="row inputRow" style="height: 40px">
                  <div class="col-md-4"></div>
                  <div class="col-md-6">
                    <div class="col-md-6">
                      <button class="forsubmit schBtn button-right1"
                        (click)="onClickSubmitcreateuser(formdataCreatenewUser.value)" aria-label="Close"
                        mat-dialog-close mat-button>
                        Create
                      </button>
                    </div>
                    <div class="col-md-6">
                      <button class="cancelButton r-20px" aria-label="Close" mat-dialog-close mat-button>
                        Cancel
                      </button>
                    </div>
                  </div>


                </div>


              </div>
            </div>
          </div>
        </div>


      </form>
      <form *ngIf="formtype=='editUser'" [formGroup]="formdataEditUser">
        <div class="row">
          <div class="col-md-11 gx-0">
            <div class="row inputRow">
              <div class="col-md-12">
                <br />
                <div class="row mb-3">
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Name</mat-label>
                      <input matInput id="commonText" name="name" placeholder="Name" [(ngModel)]="bindusernameuser"
                        formControlName="name" autocomplete="off" required />
                    </mat-form-field>
                  </div>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Username</mat-label>
                      <input matInput id="commonText" name="username" placeholder="Username" [(ngModel)]="bindnameuser"
                        formControlName="username" autocomplete="off" required />
                    </mat-form-field>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Effective From</mat-label>
                      <input [(ngModel)]="bindeffectivefromuser" placeholder="Effective From" matInput
                        [matDatepicker]="picker1" formControlName="effectiveForm" name="effectiveForm"
                        autocomplete="off" [min]="startDate" />
                      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Effective To</mat-label>
                      <input placeholder="Effective To" matInput [matDatepicker]="picker2" formControlName="effectiveTo"
                        [(ngModel)]="bindeffectivetouser" name="effectiveTo" autocomplete="off" [min]="startDate" />
                      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                      <mat-datepicker #picker2></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">

                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Role</mat-label>
                      <mat-select formControlName="role" [(ngModel)]="bindroledetailsuser">
                        <mat-select-filter [placeholder]="'Filter'" [displayMember]="'role_name'"
                          [array]="roledropdownuser1" (filteredReturn)="roledropdownuser1 = $event"></mat-select-filter>
                        <!-- <input (keyup)="onKey($event)" type="text" matInput> -->
                        <mat-option *ngFor="let i of roledropdownuser1" [value]="i.role_name">{{i.role_name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Email Id for sending details</mat-label>
                      <input matInput id="commonText" [(ngModel)]="bindemailiduser" name="email_id_send"
                        placeholder="Email Id for sending details" formControlName="email_id_send" autocomplete="off"
                        required />
                    </mat-form-field>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">
                    <mat-form-field appearance="outline" id="onlyForAdmin">
                      <mat-label>Tenant</mat-label>
                      <mat-select formControlName="tenant" [(ngModel)]="editusertenantdata" multiple>
                        <mat-select-filter [placeholder]="'Filter'" [displayMember]="'role_name'"
                          [array]="tenantdropdownuser1" (filteredReturn)="tenantdropdownuser1 = $event"></mat-select-filter>
                        <!-- <input (keyup)="onKey($event)" type="text" matInput> -->
                        <mat-option *ngFor="let i of tenantdropdownuser1" [value]="i.name">{{i.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">
                    <p class="subtextclass">Enable</p>
                    <mat-slide-toggle [(ngModel)]="bindenableuser" formControlName="userenableFlag"></mat-slide-toggle>
                  </div>
                </div>
                <div class="row inputRow" style="height: 40px">
                  <div class="col-md-4"></div>
                  <div class="col-md-6">
                    <div class="col-md-6">
                      <button class="forsubmit schBtn button-right1"
                        (click)="onClickSubmitedituser(formdataEditUser.value)" aria-label="Close" mat-dialog-close
                        mat-button>
                        Update
                      </button>
                    </div>
                    <div class="col-md-6">
                      <button class="cancelButton r-20px" aria-label="Close" mat-dialog-close mat-button>
                        Cancel
                      </button>
                    </div>
                  </div>


                </div>


              </div>
            </div>
          </div>
        </div>


      </form>
      
    </div>
  </div>
</div>
